import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {ServiceCategoriesListFilter} from './ServiceCategoriesListFilter'

const ServiceCategoriesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddServiceCategoryModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-service_category-table-toolbar='base'>
      <ServiceCategoriesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add service_category */}
      <button type='button' className='btn btn-primary' onClick={openAddServiceCategoryModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='SERVICECATEGORY.TABLE.CREATESERVICECATEGORY' />
      </button>
      {/* end::Add service_category */}
    </div>
  )
}

export {ServiceCategoriesListToolbar}
